<template>
  <div>
    <StepHeader
      :title="title"
      :theme="theme"
    />

    <StepContent :theme="theme">
      <AppButtonList
        :theme="theme"
        :buttons="buttons"
        :value="creditRating"
        @input="$_buttonList_handleInput(buttonListActionName, $event)"
      />
    </StepContent>

    <StepFooter hide-mobile>
      <AppButton
        :theme="theme"
        :loading="submitting"
        @click="$_loans_updateLead(updateLeadPayload, $_buttonList_dataLayerObject)"
      >
        Continue
      </AppButton>
    </StepFooter>
  </div>
</template>

<script>
import AppButton from '@/components/common/buttons/AppButton'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step-layout/StepContent'
import StepFooter from '@/components/common/step-layout/StepFooter'
import StepHeader from '@/components/common/step-layout/StepHeader'
import buttonList from '@/mixins/button-list'
import submitLoans from '@/mixins/submit/submit-loans'
import navigation from '@/mixins/navigation'

export default {
  // Name
  name: 'CreditRating',

  // Components
  components: {
    AppButtonList,
    StepContent,
    StepHeader,
    AppButton,
    StepFooter
  },

  // Mixins
  mixins: [
    buttonList,
    submitLoans,
    navigation
  ],

  // Props
  props: {
    title: {
      type: String,
      default: 'What Is Your Estimated Credit Score?'
    },

    theme: {
      type: String,
      default: 'blue'
    }
  },

  // Data
  data () {
    return {
      buttonListActionName: 'setCreditRating',
      buttonListFieldName: 'creditRating',
      buttons: [{
        text: 'Good (Over 650)',
        dataLayer: 'good',
        value: 'Good (650 +)'
      }, {
        text: 'Fair (550 - 650)',
        dataLayer: 'fair',
        value: 'Fair (550 - 649)'
      }, {
        text: 'Poor (Under 550)',
        dataLayer: 'poor',
        value: 'Poor (400 - 549)'
      }, {
        text: 'Current Bankruptcy',
        dataLayer: 'bankruptcy',
        value: 'Current Bankruptcy'
      }, {
        text: 'No Credit / Unsure',
        dataLayer: 'nocredit',
        value: 'No Credit'
      }],
      buttonListDataLayerStepName: 'spring_ploan_credit_rating'
    }
  },

  computed: {
    creditRating () {
      return this.$store.state.customer.credit_rating
    },
    updateLeadPayload () {
      return { credit_rating: this.creditRating }
    }
  },

  watch: {
    $_navigation_triggerContinue: async function (val) {
      if (val) await this.$_loans_updateLead(this.updateLeadPayload, this.$_buttonList_dataLayerObject)
      this.$store.dispatch('setTriggerContinue', false)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
